import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import { Label as LabelIcon } from "@mui/icons-material";
import EmptyStateCard from "../../../../components/EmptyStateCard";
import useEvents from "../../../../hooks/useEvents";

type EmptyLabelsProps = {
  onAddLabel: () => void;
};

const EmptyLabels = ({ onAddLabel }: EmptyLabelsProps) => {
  const events = useEvents();
  
  return (
    <Box data-testid="EmptyLabelsView" style={{ margin: 24 }}>
      <EmptyStateCard
        text="Create custom labels to organize and categorize content throughout your coaching platform."
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500, alignItems: "center" }} spacing={2}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            Labels help you organize clients, protocols, exercises, and other content 
            with custom categories and colors. Use them to filter and find information 
            quickly across the entire system.
          </Typography>
          
          <StandardButton
            data-testid="EmptyLabelsView-Button"
            variant="primary"
            startIcon={<LabelIcon />}
            onClick={() => {
              onAddLabel();
              events.logButtonClick({
                buttonName: "Add Your First Label",
                pageName: "Admin",
                tabName: "Labels",
              });
            }}
            style={{ fontSize: 16 }}
          >
            Add Your First Label
          </StandardButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyLabels;